import { initSentry } from "./lib/sentry"

initSentry()

import { StrictMode, lazy, Suspense } from "react"
import { createRoot } from "react-dom/client"
import { QueryClientProvider } from "@tanstack/react-query"
import { WalletContextProvider } from "./components/WalletContextProvider"
import { RouterProvider } from "react-router-dom"
import { router } from "./routes"
import { queryClient } from "./lib/query-client"
import { initServiceWorkerLifecycle } from "./lib/register-sw"
import "./lib/i18n/setup"
import "./index.css"

initServiceWorkerLifecycle()

// ponytail: dynamic import so prod builds never pull react-query-devtools
const ReactQueryDevtools = import.meta.env.DEV
  ? lazy(() =>
      import("@tanstack/react-query-devtools").then((m) => ({
        default: m.ReactQueryDevtools,
      })),
    )
  : null

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <WalletContextProvider>
        <RouterProvider router={router} />
        {ReactQueryDevtools ? (
          <Suspense fallback={null}>
            <ReactQueryDevtools initialIsOpen={false} />
          </Suspense>
        ) : null}
      </WalletContextProvider>
    </QueryClientProvider>
  </StrictMode>
)
